{
  "code": "EX-00",
  "GLOBAL_DEVEXTREME": {
    "Done": "Agendar"
  }
}
